module.exports = __webpack_public_path__ + "img/locationMarker.f6e92d9e.png";